export const slugToPascalCase = (str: string) =>
	str
		.split('-')
		.map((el) => el[0].toUpperCase() + el.substring(1))
		.join('')

export const slugify = (str: string) => str.toLowerCase().split(' ').join('-')
